<template>
  <div class="flex flex-col mr-0">
    <!-- แถวบน: ปุ่ม/ไอคอน CSG + BORA อยู่ในแถวเดียวกัน -->
    <div class="flex flex-wrap items-center">
      <!-- CSG -->
      <div
        class="information-value flex flex-wrap items-center mr-2"
        :title="`ระบบเงินอุดหนุนเพื่อการเลี้ยงดูเด็กแรกเกิด กรมกิจการเด็กและเยาวชน (CSG)${
          infoData?.linking_system?.find(i => i.system === 'CSG')?.updated_at
            ? '\nข้อมูล ณ วันที่: ' + infoData.linking_system.find(i => i.system === 'CSG').updated_at
            : ''
        }`"
      >
        <!-- กรณีที่มีข้อมูลแล้ว แสดงเป็นไอคอนวงกลมกดได้ -->
        <div class="inline-block w-9 h-9" v-show="isCSGConnected">
          <button
            class="bg-gray-100 cursor-pointer rounded-full text-center w-9 h-9 mr-2"
            @click="openConnectModal('CSG')"
            style="border: 1px solid lightpink;"
          >
            <img class="connection-tags" :src="require('@/assets/images/logo/CSG.png')" />
          </button>
        </div>

        <!-- กรณีที่ยังไม่มีข้อมูล แสดงเป็นปุ่มหลัก -->
        <div class="text-center" v-show="isEligibleForCSG && !isCSGConnected">
          <a class="btn btn-primary" @click="openConnectModal('CSG')">
            <span class="bg-gray-100 cursor-pointer rounded-full text-center w-5 mr-2">
              <img class="connection-tags" :src="require('@/assets/images/logo/CSG.png')" />
            </span>
            ตรวจสอบข้อมูลกับ CSG
          </a>
        </div>
      </div>

      <!-- BORA -->
      <div
        class="information-value flex flex-wrap items-center mr-2"
        title="ข้อมูลทะเบียนราษฎร์ กรมการปกครอง ผ่าน Linkage Center 2.0 สป.พม. (BORA)"
      >
        <div class="inline-block w-9 h-9" v-show="isBORAConnected">
          <button
            class="bg-gray-100 cursor-pointer rounded-full text-center w-9 h-9 mr-2"
            style="border: 1px solid lightpink;"
            @click="openConnectModal('BORA')"
          >
            <img class="connection-tags" :src="require('@/assets/images/logo/BORA.png')" />
          </button>
        </div>
        <div class="text-center" v-show="!isBORAConnected">
          <a class="btn btn-primary" @click="openConnectModal('BORA')">
            <span class="bg-gray-100 cursor-pointer rounded-full text-center w-5 mr-2">
              <img class="connection-tags" :src="require('@/assets/images/logo/BORA.png')" />
            </span>
            ตรวจสอบข้อมูลกับ BORA
          </a>
        </div>
      </div>
    </div>

    <!-- CSG Modal -->
    <div
      id="edit-connect-modal"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content bg-theme-39">
          <a
            data-dismiss="modal"
            href="javascript:;"
            @click="cancelConnectModalForm"
          >
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <span class="w-9 h-9 mr-0.5" v-html="img_connect_logo" />
            <h3 class="text-theme-1 font-semibold text-md">
              ตรวจสอบข้อมูลกับ {{ connect_name }}
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
              <CSG
                v-show="infoData"
                @close-modal="cancelConnectModalForm = false"
                :infoData="infoData"
                :csg_data="csg_data"
                :infoToBeCompareCSG="infoToBeCompareCSG"
                @update-state="handleCSGUpdate"
              />
              <!-- footer -->
              <div class="col-span-12 flex items-center mt-4 justify-end">
                <button
                  class="btn btn-primary ml-2"
                  data-dismiss="modal"
                  @click="cancelConnectModalForm"
                >
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BORA Modal -->
    <div
      id="edit-connect-modal-bora"
      class="modal"
      tabindex="-1"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content bg-theme-39">
          <a
            data-dismiss="modal"
            href="javascript:;"
            @click="cancelConnectModalForm"
          >
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-header">
            <h3 class="text-theme-1 font-semibold text-md">
              ตรวจสอบข้อมูลกับ BORA
            </h3>
          </div>
          <div class="modal-body p-6">
            <div class="bg-white rounded-md p-4">
              <BORA
                v-show="infoData"
                @close-modal="cancelConnectModalForm = false"
                :infoData="infoData"
                :bora_data="bora_data"
                :infoToBeCompareBORA="infoToBeCompareBORA"
                @update-state="handleBORAUpdate"
              />
              <!-- footer -->
              <div class="col-span-12 flex items-center mt-4 justify-end">
                <button
                  class="btn btn-primary ml-2"
                  data-dismiss="modal"
                  @click="cancelConnectModalForm"
                >
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, watch, nextTick,inject } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import CSG from "@/views/member/container/CSG.vue"
import BORA from "@/views/member/container/BORA.vue"
import { Buffer } from 'buffer';
import Swal from "sweetalert2";
import { useBoraData } from '@/utils/useBoraData';
const { getPersonInfoFromBora } = useBoraData();
const formData = ref({});
const store = useStore();
const generateLogoHTML = ref("");
const cancelData = ref(false);
const openModalStatus = ref(false);
const connect_name = ref("CSG");
const infoToBeCompareCSG = ref([]);
const infoToBeCompareBORA = ref([]);
const bora_data = ref({});
const csg_data = ref({});
const img_connect_logo = ref("");
const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  infoData: Object,
});
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});
const emit = defineEmits(['update-profile']);
const refreshMemberData = inject('refreshMemberData', null);
// watch(() => props.infoData, (newInfoData, oldInfoData) => {
// }, { deep: true, immediate: true });
// const isCSGUpdating = ref(false);
const handleCSGUpdate = async () => {
   if (refreshMemberData) {
    refreshMemberData();
    return;
  }
  // emit('update-profile');
  //  if (isCSGUpdating.value) {
  //   return;
  // }
  //  isCSGUpdating.value = true;
// emit('update-profile');
    // setTimeout(() => {
    //   isCSGUpdating.value = false;
    // }, 1000);
};

const isEligibleForCSG = computed(() => {
    if (!props.infoData) {
        return false;
    }
    
    const isAgeOK = checkAgeLTE5Y11M(props.infoData.birthdate);
    const isThai = props.infoData.nationality === 'ไทย';

    return isAgeOK && isThai;
});

// const isCSGConnected = computed(() => {
//     const isConnected = props.infoData?.linking_system?.includes('CSG');
//     // console.log(`CSG CONNECTED: ${isConnected}`);
//     return isConnected;
// });
const isCSGConnected = computed(() => {
    // ใช้ .some() เพื่อหาว่ามี Object ตัวไหนที่มี system === 'CSG' หรือไม่
    const isConnected = props.infoData?.linking_system?.some(item => {
        // รองรับทั้งกรณีที่เป็น Object ใหม่ {system: 'CSG'} 
        // เผื่อกรณีข้อมูลเก่าที่เป็น String 'CSG' หลุดมา
        return (typeof item === 'object' && item !== null) 
            ? item.system === 'CSG' 
            : item === 'CSG';
    });
    return !!isConnected;
});
const isBORAConnected = computed(() => {
  const isConnected = props.infoData?.linking_system?.some(item => {
        return (typeof item === 'object' && item !== null) 
            ? item.system === 'BORA' 
            : item === 'BORA';
    });
  return isConnected;
});

 const checkAgeLTE5Y11M = (formBirthdate) => {
    const birthDate = new Date(formBirthdate);
    
    const today = new Date();
    const cutoffDate = new Date(birthDate);
    cutoffDate.setFullYear(birthDate.getFullYear() + 6);
    cutoffDate.setDate(cutoffDate.getDate() - 1);
    
    return today <= cutoffDate;
};
const infoDataTags = computed(() => {
  console.log(props.infoData);
  return props.infoData.tags;
});
const cancelConnectModalForm = async () => {
   cash('#edit-connect-modal').modal('hide');
  cancelData.value = true;
  openModalStatus.value = false;
  //  emit('update-profile')
};
const openConnectModal = async (link) => {
  if(link == "BORA"){
    let _CompareDataBORA = await CompareDataBORA();
    if(_CompareDataBORA == "no_login_thaid"){
      return;
    }
      if (_CompareDataBORA == "error") {
      return;
    }
     if (!_CompareDataBORA) {
      swalCustom.fire({
        text: "ไม่พบการเปลี่ยนแปลงข้อมูลจากทะเบียนราษฎร์",
        // icon: "",
        confirmButtonText: "ปิด",
      });
      return;
    }
    await cash("#edit-connect-modal-bora").modal("show");
    // putLinkingSystem("BORA");
    openModalStatus.value = true;
    cancelData.value = false;
  }else if(link == "CSG"){
  let _CompareDataCSG = await CompareDataCSG();
  if(_CompareDataCSG == 'error'){
    return;
  }
  if(_CompareDataCSG == 'sent_to_csg_no'){
     swalCustom.fire({
                                    text: "ไม่ส่งข้อมูลไปยังระบบ CSG เนื่องจากครอบครัว มีเงิน 100,000 บาท ต่อคน ต่อปี",
                                    // icon: "",
                                    confirmButtonText: "ปิด",
                                });
return;
  }
  if(_CompareDataCSG == 'sent_to_csg'){
 swalCustom
          .fire({
            text: "ไม่พบข้อมูลจาก CSG ยืนยันเพื่อส่งข้อมูลไปยังระบบ CSG หรือไม่",
            icon: "info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
  let example_sent_to_csg = {
          "general_info": {
            hh_id: props.infoData?.hh_id || null,
            fam_id: props.infoData?.fam_id || null,
            hnum: props.infoData?.hnum || null,
            village_code: props.infoData?.village_code || null,
            village_name: props.infoData?.village_name || null,
            moo: props.infoData?.moo || null,
            soi: props.infoData?.soi || null,
            road: props.infoData?.road || null,
            tumbol_code: props.infoData?.tumbol_code || null,
            tumbol_name: props.infoData?.tumbol_name || null,
            amphur_code: props.infoData?.amphur_code || null,
            amphur_name: props.infoData?.amphur_name || null,
            province_code: props.infoData?.province_code || null,
            province_name: props.infoData?.province_name || null,
            postcode: props.infoData?.postcode || null,
            mso_osm: props.infoData?.mso_osm || null,
            title: props.infoData?.title || null,
            name: props.infoData?.name || null,
            surname: props.infoData?.surname || null,
            national_id: props.infoData?.national_id || null,
            mobile_num: props.infoData?.mobile_num || null,
            birthdate: props.infoData?.birthdate || null,
            sex: props.infoData?.sex || null,
            marital_status: props.infoData?.marital_status || null,
            nationality: props.infoData?.nationality || null,
            nationality_other: props.infoData?.nationality_other || null,
            religion: props.infoData?.religion || null,
            vital_status: props.infoData?.vital_status || null,
            edu_status: props.infoData?.edu_status || null,
            edu_level: props.infoData?.edu_level || null,
            attend_socact: props.infoData?.attend_socact || null,
            father: props.infoData?.father || null,
            mother: props.infoData?.mother || null,
            status: props.infoData?.status || null,
            modified_by: props.infoData?.modified_by || null,
            msoid: props.infoData?.msoid || null
          },
          disability: props.infoData?.disability || null,
          member_cnt: null,
          sum_income: null,
          csg_status: props.infoData?.csg?.status || null
        };
         const url_family = `${process.env.VUE_APP_BASE_API}family/getFamilySurveyById`;
  let res = null;
  try {const token = store.getters["userAuth/getToken"];
    const response = await axios.post(
        url_family, 
        { famId: props.infoData?.fam_id }, 
          {headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    }}
    );
    
    const res = response.data; 
   
   example_sent_to_csg.member_cnt = res?.memberinfo?.member_cnt ?? null;
    example_sent_to_csg.sum_income = res?.memberinfo?.sum_income ?? null;} catch (error) {
       if (swalCustom) {
         swalCustom.fire({
             text: "ไม่สามารถดึงข้อมูลครอบครัวได้ โปรดลองอีกครั้ง",
             icon: "error",
             confirmButtonText: "ปิด",
         });
    }
    return;
}
   const apiConfigCSG = {
    url: `${process.env.VUE_APP_BASE_API}dc/send2Ext`,
    method: "POST",
    data: {
      target_system: "csg",
      payload: example_sent_to_csg
    }
};

let promises = [];
promises.push(
    axios(apiConfigCSG)
        .then(response => ({ success: true, response }))
        .catch(error => ({ success: false, error }))
);
Promise.all(promises.map((p) => p.catch((e) => e))) // p.catch((e) => e) ตรงนี้อาจจะไม่จำเป็นหากคุณใช้ .then/.catch ในขั้นตอนที่ 2 แล้ว
    .then((results) => {
        // if (results.length > 0 && results[0].success) {
        //     const csg_response_data = results[0].response.data;
        //     // ทำงานต่อกับข้อมูล csg_response_data
        // }
        if (csg_result && csg_result.success) {
         swalCustom.fire({
                        text: "ส่งข้อมูลไปยังระบบ CSG สำเร็จ",
                        icon: "success",
                        timer: 3000,
                        confirmButtonText: "ปิด",
                      })
        }else{
            swalCustom.fire({
                    text: "ส่งไปยัง CSG ไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    confirmButtonText: "ปิด",
                });
        }
            return;
    })
    .catch((finalError) => {
                     swalCustom.fire({
                    text: "ทำรายการส่งไปยัง CSG ไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    confirmButtonText: "ปิด",
                });
            return;
    });
            }
            return;
            })
             .catch((error) => {
                  swalCustom.fire({
                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    confirmButtonText: "ปิด",
                  });
                  console.log(error);
                  return;
                });
                return;
  }
  if(!_CompareDataCSG){
    swalCustom.fire({
                                    text: "ไม่พบการเปลี่ยนแปลงข้อมูลจากระบบ CSG",
                                    // icon: "",
                                    confirmButtonText: "ปิด",
                                });
    return;
  }
  await cash('#edit-connect-modal').modal('show');
  putLinkingSystem('CSG');
  openModalStatus.value = true;
  cancelData.value = false;
  }else{
    console.log('no')
  }
};
const isAllDataMatched = async (compareArray,link) => {
  if(link == 'CSG'){
return compareArray.every(item => {
        // แปลงค่าเป็น String และ trim ช่องว่างก่อนเปรียบเทียบ
        const textA = String(item.text || '').trim();
        const textB = String(item.csg_text || '').trim();
        return textA === textB;
    });
  }else if(link == 'BORA'){
    return compareArray.every(item => {
        // แปลงค่าเป็น String และ trim ช่องว่างก่อนเปรียบเทียบ
        const textA = String(item.text || '').trim();
        const textB = String(item.bora_text || '').trim();
        return textA === textB;
    });
  }
}
const decode = async (string) => {
  return Buffer.from(string, 'base64').toString('utf8');
}
const check_address = (data) => {
  if(data.trim() != ''){
    return data
  }else{
    return "-";
  }
}
// แปลง dateofbirth จากรูปแบบ พ.ศ. YYYYMMDD (เช่น 25380101) เป็น ISO date
const formatDateofbirthToDate = (dateofbirth) => {
  if (!dateofbirth || String(dateofbirth).trim() === '') return ''
  const s = String(dateofbirth).trim()
  if (s.length !== 8) return ''
  const yearBE = parseInt(s.slice(0, 4), 10)
  const month = s.slice(4, 6)
  const day = s.slice(6, 8)
  const yearCE = yearBE - 543
  const monthNum = parseInt(month, 10)
  const dayNum = parseInt(day, 10)
  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) return ''
  const date = new Date(Date.UTC(yearCE, monthNum - 1, dayNum, 0, 0, 0, 0))
  if (isNaN(date.getTime())) return ''
  return date.toISOString()
}
// แยกชื่อเต็มเป็น name กับ surname (คำสุดท้าย = นามสกุล)
const splitFullName = (full) => {
  if (!full || String(full).trim() === '') return { name: '', surname: '' }
  const parts = String(full).trim().split(/\s+/)
  if (parts.length === 1) return { name: parts[0], surname: '' }
  const surname = parts.pop()
  const name = parts.join(' ')
  return { name, surname }
}
const CompareDataBORA = async (link) => {
  console.log(props.infoData);
  const pid = props.infoData?.national_id || "";
  if (!pid) {
    swalCustom.fire({
      text: "ไม่พบเลขบัตรประชาชนของสมาชิกสำหรับตรวจสอบกับทะเบียนราษฎร์",
      icon: "warning",
      confirmButtonText: "ปิด",
    });
    return "no_pid";
  }
  const data = Object.freeze(await getPersonInfoFromBora(pid));
  console.log(data)
  if(!data){
    return 'no_login_thaid';
  }
  if (data) {
    const fatherSplit = splitFullName(data.fathername)
    const motherSplit = splitFullName(data.mothername)
    bora_data.value = {
      national_id: data.pid || '',
      title: data.title || '',
      name: data.firstname || '',
      surname: data.lastname || '',
      sex: (data.gender === "1" || String(data.gender).includes("ชาย")) 
    ? "ชาย" 
    : (data.gender === "2" || String(data.gender).includes("หญิง")) 
        ? "หญิง" 
        : (data.gender || ''),
      birthdate: formatDateofbirthToDate(data.dateofbirth),
      nationality: data.nationality || '',
      // vital_status: data.personstatus === "ปกติ" ? 1 : 0,
      father: {
        national_id: data.fatherpid || '',
        name: fatherSplit.name,
        surname: fatherSplit.surname,
        nationality: data.fathernationality || ''
      },
      mother: {
        national_id: data.motherpid || '',
        name: motherSplit.name,
        surname: motherSplit.surname,
        nationality: data.mothernationality || ''
      },
      moo: data.moo,
      province_name: data.province,
      road: data.road || '',
      soi: data.soi || '',
      hnum: data.housenumber,
      amphur_name: data.district,
      tumbol_name: data.subdistrict,
      alley: data.alley,
      houseid: data.houseid
    };
  } else {
    console.warn("ไม่สามารถดึงข้อมูลจาก BORA ได้");
  }
  // bora_data.value = {
  //   title: "นาย",
  //   name: "เดชาพล",
  //   surname:"พี่บาส",
  //   religion:"อิสลาม",
  //   sex: "ชาย",
  //   nationality: "ไทย",
  //   vital_status: 1,
  //   birthdate:"2016-01-08T00:00:00.000Z",
  //   moo: 4,
  //   postcode: '',
  //   province_code: 10,
  //   province_name: 'กรุงเทพมหานคร',
  //   road: '',
  //   soi: '',
  //   hnum:'139',
  //   amphur_code: "1001",
  //   amphur_name: "พระนคร",
  //   tumbol_code: "100109",
  //   tumbol_name: "ชนะสงคราม",
  //   village_code: "10010901",
  //   village_name: "ตรอกเขียนนิวาศน์"
  // };
  const token = store.getters["userAuth/getToken"];

  infoToBeCompareBORA.value = [
      {
        field: "title",
        label: "คำนำหน้า",
        text: props.infoData?.title || "-",
        bora_text: bora_data.value?.title || "-"
      },
      {
        field: "name",
        label: "ชื่อ",
        text: props.infoData?.name || "-",
        bora_text: bora_data.value?.name || "-"
      },
      {
        field: "surname",
        label: "นามสกุล",
        text: props.infoData?.surname || "-",
        bora_text: bora_data.value?.surname || "-"
      },
      {
        field: "national_id",
        label: "เลขบัตรประชาชน",
        text: props.infoData?.national_id || "-",
        bora_text: bora_data.value?.national_id || "-"
      },
      {
        field: "nationality",
        label: "สัญชาติ",
        text: props.infoData?.nationality || "-",
        bora_text: bora_data.value?.nationality || "-"
      },
      {
        field: "sex",
        label: "เพศ",
        text: props.infoData?.sex || "-",
        bora_text: bora_data.value?.sex || "-"
      },
      // {
      //   field: "vital_status",
      //   label: "สถานะการมีชีวิต",
      //   text: rawDataToText(props.infoData?.vital_status, "vital_status") || "-",
      //   bora_text: bora_data.value?.vital_status ? rawDataToText(bora_data.value?.vital_status, "vital_status") : "-"
      // },
      {
        field: "birthdate",
        label: "วัน/เดือน/ปีเกิด",
        text: rawDataToText(props.infoData?.birthdate, "birthdate") || "-",
        bora_text: rawDataToText(bora_data.value?.birthdate, "birthdate") || "-"
      },
      {
        field: "father_national_id",
        label: "เลขบัตรประชาชนบิดา",
        text: props.infoData?.father?.national_id || "-",
        bora_text: bora_data.value?.father?.national_id || "-"
      },
      {
        field: "father_name",
        label: "ชื่อบิดา",
        text: props.infoData?.father?.name || "-",
        bora_text: bora_data.value?.father?.name || "-"
      },
      {
        field: "father_surname",
        label: "นามสกุลบิดา",
        text: props.infoData?.father?.surname || "-",
        bora_text: bora_data.value?.father?.surname || "-"
      },
      {
        field: "father_nationality",
        label: "สัญชาติบิดา",
        text: props.infoData?.father?.nationality || "-",
        bora_text: bora_data.value?.father?.nationality || "-"
      },
      {
        field: "mother_national_id",
        label: "เลขบัตรประชาชนมารดา",
        text: props.infoData?.mother?.national_id || "-",
        bora_text: bora_data.value?.mother?.national_id || "-"
      },
      {
        field: "mother_name",
        label: "ชื่อมารดา",
        text: props.infoData?.mother?.name || "-",
        bora_text: bora_data.value?.mother?.name || "-"
      },
      {
        field: "mother_surname",
        label: "นามสกุลมารดา",
        text: props.infoData?.mother?.surname || "-",
        bora_text: bora_data.value?.mother?.surname || "-"
      },
      {
        field: "mother_nationality",
        label: "สัญชาติมารดา",
        text: props.infoData?.mother?.nationality || "-",
        bora_text: bora_data.value?.mother?.nationality || "-"
      },
      {
        field: "address",
        label: "ที่อยู่",
        text: await check_address(`${props.infoData?.hnum ? props.infoData?.hnum + ' ' : ''}` + 
              `${props.infoData?.moo ? 'หมู่ ' + props.infoData?.moo : ''} ` +
              `${props.infoData?.village_name ? props.infoData?.village_name : ''} ` + 
              `${props.infoData?.soi ? 'ซอย ' + props.infoData?.soi : ''} ` + 
              `${props.infoData?.road ? 'ถนน ' + props.infoData?.road : ''} ` + 
              `${props.infoData?.tumbol_name ? 'ตำบล' + props.infoData?.tumbol_name : ''} ` + 
              `${props.infoData?.amphur_name ? 'อำเภอ' + props.infoData?.amphur_name : ''} ` + 
              `${props.infoData?.province_name ? 'จังหวัด' + props.infoData?.province_name : ''} ` + 
              `${props.infoData?.postcode ? props.infoData?.postcode : ''}`),
        bora_text: await check_address(`${bora_data.value?.hnum ? bora_data.value?.hnum + ' ' : ''}` + 
              `${bora_data.value?.moo ? 'หมู่ ' + bora_data.value?.moo : ''} ` +
              `${bora_data.value?.village_name ? bora_data.value?.village_name : ''} ` + 
              `${bora_data.value?.alley ? 'ตรอก ' + bora_data.value?.alley : ''} ` + 
              `${bora_data.value?.soi ? 'ซอย ' + bora_data.value?.soi : ''} ` + 
              `${bora_data.value?.road ? 'ถนน ' + bora_data.value?.road : ''} ` + 
              `${bora_data.value?.tumbol_name ? 'ตำบล' + bora_data.value?.tumbol_name : ''} ` + 
              `${bora_data.value?.amphur_name ? 'อำเภอ' + bora_data.value?.amphur_name : ''} ` + 
              `${bora_data.value?.province_name ? 'จังหวัด' + bora_data.value?.province_name : ''} ` + 
              `${bora_data.value?.houseid ? 'รหัสบ้าน ' + bora_data.value?.houseid : ''}`)
      }
  ];

  // const config = {
  //   url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
  //   method: "PUT",
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //     "Content-Type": `application/json; charset=utf-8`,
  //   },
  //   data: {
  //     update: update_data,
  //   },
  // };
  // axios(config).then((res) => {
  //   emit("update-state");
  // });

 const allDataMatch = await isAllDataMatched(infoToBeCompareBORA.value,"BORA");
if (allDataMatch) {
  const hasCSG = props.infoData?.linking_system?.some(item => 
    (typeof item === 'object' ? item.system : item) === 'CSG'
  );

  if (!hasCSG) {
    putLinkingSystem(link);
  }
  return false;
} else {
  return true;
}
}
const CompareDataCSG = async (link) => {
   const config = {
                    url: `https://mso-logbook.m-society.go.th/api/dc/csg/v1?queryCode=MSO&EQC_IDCARD=${props.infoData?.national_id}`,
                    method: "GET",
                    headers:{
                        Authorization: `Bearer -69dn6ubuq7ln5q6qj0gjsgfcdgvw7yyzwubwa76sc1nol61oq`
                    }
   }
                await axios(config)
                .then((res)=>{
                  csg_data.value = res.data.rows[0] ? res.data.rows[0]:{};
                }).catch((error)=>{console.log(error)})
  //  csg_data.value = {
  //   "EQ_GID_REGISTER": "พมจ.",
  //   "EQ_GID": "นครปฐม",
  //   "STATUS": "ได้รับเงิน",

  //   "EQC_CODE_PRENAME": "เด็กหญิง",
  //   "EQC_FIRSTNAME": "ณัฐนิชา",
  //   "EQC_LASTNAME": "ทด",
  //   "EQC_BIRTH_DATE": "2025-10-30T00:00:00.000Z",
  //   "EQ_FATHER_IDCARD": "1131313131315",
  //   "EQ_CODE_FATHER_PRENAME": "นาย",
  //   "EQ_FATHER_NAME": "ทนง ทด",
  //   "EQ_FATHER_NATIONALITY": "ไทย",
  //   "EQ_MOTHER_IDCARD": "1271271271123",
  //   "EQ_CODE_MOTHER_PRENAME": "นาง",
  //   "EQ_MOTHER_NAME": "ทนาง ทด",
  //   "EQ_MOTHER_NATIONALITY": "ไทย",
  //   "EQ_REGISTER_TYPE": "ผู้ปกครอง",

  //   "EQ_IDCARD": "2345678901234",
  //   "EQ_CODE_PRENAME": "นาย",
  //   "EQ_FIRSTNAME": "ชื่อผู้ปกครอง",
  //   "EQ_LASTNAME": "สกุลผู้ปกครอง",
  //   "EQ_BIRTHDAY": "2025-10-30T00:00:00.000Z",
  //   "EQ_NATIONALITY": "ไทย",
  //   "csg_status": "เด็กไม่อยู่ในพื้นที่"
  // };
const token = store.getters["userAuth/getToken"];
  // let promises = [];
  
  // let apiConfig = {
  //   url: `${process.env.VUE_APP_BASE_API}csg/test`,
  //   method: "GET",
  //   // headers: {
  //   //   Authorization: `Bearer ${token}`,
  //   //   "Content-Type": `application/json; charset=utf-8`,
  //   // },
  //   // data: {
  //   //   // เลขบัตรประชาชน
  //   // }
  // };
  
  // if (apiConfig) {
  //   promises.push(
  //     axios(apiConfig)
  //       .then(response => ({ success: true, response }))
  //       .catch(error => ({ success: false, error }))
  //   );
  // }
  // let results = await Promise.all(promises);
  // if (results.length > 0 && results[0].success) {
  //     csg_data.value = results[0].response.data; 
  // } else {
  //     swalCustom.fire({
  //                                   text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
  //                                   icon: "warning",
  //                                   confirmButtonText: "ปิด",
  //                               });
  //                               return false;
  // }
  // csg_data.value = {};
if (Object.keys(csg_data.value).length === 0) {
    // csg_data.value เป็น {}
      const url_family = `${process.env.VUE_APP_BASE_API}family/getFamilySurveyById`;
  let res = null;
  try {
    const response = await axios.post(
        url_family, 
        { famId: props.infoData?.fam_id }, 
          {headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    }}
    );
    
    const res = response.data; 
   let member_cnt = res?.memberinfo?.member_cnt ?? null;
    let sum_income = res?.memberinfo?.sum_income ?? null;
    let  isEligibleForCSG =
        (sum_income * 12) / member_cnt <= 100000;
if(isEligibleForCSG){

return 'sent_to_csg';
}} catch (error) {
    console.error("Error fetching family survey data:", error);
    if (swalCustom) {
         swalCustom.fire({
             text: "ไม่สามารถดึงข้อมูลครอบครัวได้ โปรดลองอีกครั้ง",
             icon: "error",
             confirmButtonText: "ปิด",
         });
    }
    res = {}; 
    let member_cnt = 0;

     return 'sent_to_csg_error';
}
return 'sent_to_csg_no';
}
  infoToBeCompareCSG.value = [
    {
      field: "title",
      label: "คำนำหน้า",
      text: props.infoData?.title || '-',
      csg_text: (csg_data.value?.EQC_CODE_PRENAME || '-').replace('น.ส.','นางสาว')
    },
    {
      field: "name",
      label: "ชื่อ",
      text: props.infoData?.name || '-',
      csg_text: csg_data.value?.EQC_FIRSTNAME || '-'
    },
    {
      field: "surname",
      label: "นามสกุล",
      text: props.infoData?.surname || '-',
      csg_text: csg_data.value?.EQC_LASTNAME || '-'
    },
    {
      field: "birthdate",
      label: "วัน/เดือน/ปีเกิด",
      text: rawDataToText(props.infoData?.birthdate, "birthdate"),
      csg_text: rawDataToText(convertThaiDateToISO(csg_data.value?.EQC_BIRTH_DATE), "birthdate"),
    },
    {
      field: "father_idcard",
      label: "เลขบัตรประชาชน (บิดา)",
      text: props.infoData?.father?.national_id || '-',
      csg_text: csg_data.value?.EQ_FATHER_IDCARD || '-'
    },
    {
      field: "father_name",
      label: "ชื่อ-นามสกุล (บิดา)",
      text: (props.infoData.father?.title || '') + ' ' + (props.infoData.father?.name || '') + ' ' + (props.infoData.father?.surname || ''),
      csg_text: (csg_data.value?.EQ_CODE_FATHER_PRENAME || '-') + ' ' + (csg_data.value?.EQ_FATHER_NAME || '-')+ ' ' + (csg_data.value?.EQ_FATHER_LNAME || '-')
    },
    {
      field: "father_nationality",
      label: "สัญชาติ (บิดา)",
      text: props.infoData?.father?.nationality || '-',
      csg_text: csg_data.value?.EQ_FATHER_NATIONALITY ? csg_data.value?.EQ_FATHER_NATIONALITY.replace('สัญชาติ','') : '-'
    },
    {
      field: "mother_idcard",
      label: "เลขบัตรประชาชน (มารดา)",
      text: props?.infoData.mother?.national_id || '-',
      csg_text: csg_data.value?.EQ_MOTHER_IDCARD || '-'
    },
    {
      field: "mother_name",
      label: "ชื่อ-นามสกุล (มารดา)",
      text: (props.infoData?.mother?.title || '') + ' ' + (props.infoData?.mother?.name || '') + ' ' + (props.infoData.mother?.surname || ''),
      csg_text: (csg_data.value?.EQ_CODE_MOTHER_PRENAME || '-').replace('น.ส.','นางสาว') + ' ' + (csg_data.value?.EQ_MOTHER_NAME || '-')+ ' ' + (csg_data.value?.EQ_MOTHER_LNAME || '-')
    },
    {
      field: "mother_nationality",
      label: "สัญชาติ (มารดา)",
      text: props.infoData?.mother?.nationality || '-',
      csg_text: csg_data.value?.EQ_MOTHER_NATIONALITY ? csg_data.value?.EQ_MOTHER_NATIONALITY.replace('สัญชาติ','') : '-'
    },
    // {
    //   field: "csg_status",
    //   label: "สถานะเด็ก<span class="text-red"> *</span>",
    //   text: props.infoData?.csg?.status || '-',
    //   csg_text: csg_data.value?.csg_status || '-'
    // },
    {
      field: "STATUS",
      label: 'สถานะลงทะเบียน<span class="text-red"> *</span>',
      text: props.infoData?.csg?.register_status || '-',
      csg_text: csg_data.value?.STATUS || '-'
    },
    {
      field: "EQ_REGISTER_TYPE",
      label: 'ประเภทผู้ลงทะเบียน<span class="text-red"> *</span>',
      text: props.infoData?.csg?.registrant_type || '-',
      csg_text: csg_data.value?.EQ_REGISTER_TYPE || '-'
    }
  ];
 let parentAllDataMatch=true;
 let csg_AllDataMatch =true;
 // || props.infoData?.parent?.csg?.registrant_type === 'ผู้ปกครอง'
  if (csg_data.value?.EQ_REGISTER_TYPE === 'ผู้ปกครอง') {
      let parent_data = [{
      field: "EQ_IDCARD",
      label: 'บัตรประชาชน (ผู้ปกครอง)<span class="text-red"> *</span>',
      text: props.infoData?.parent?.national_id || '-',
      csg_text: csg_data.value?.EQ_IDCARD || '-'
    }, {
      field: "EQ_CODE_PRENAME",
      label: 'คำนำหน้า (ผู้ปกครอง)<span class="text-red"> *</span>',
      text: props.infoData?.parent?.title || '-',
      csg_text: (csg_data.value?.EQ_CODE_PRENAME || '-').replace('น.ส.','นางสาว')
    }, {
      field: "EQ_FIRSTNAME",
      label: 'ชื่อ (ผู้ปกครอง)<span class="text-red"> *</span>',
      text: props.infoData?.parent?.name || '-',
      csg_text: csg_data.value?.EQ_FIRSTNAME || '-'
    }, {
      field: "EQ_LASTNAME",
      label: 'สกุล (ผู้ปกครอง)<span class="text-red"> *</span>',
      text: props.infoData?.parent?.surname || '-',
      csg_text: csg_data.value?.EQ_LASTNAME || '-'
    }, {
      field: "EQ_BIRTHDAY",
      label: 'วัน/เดือน/ปีเกิด (ผู้ปกครอง)<span class="text-red"> *</span>',
      text: rawDataToText(props.infoData?.parent?.birthdate, "birthdate"),
      csg_text: rawDataToText(convertThaiDateToISO(csg_data.value?.EQ_BIRTHDAY), "birthdate"),
    }, {
      field: "EQ_NATIONALITY",
      label: 'สัญชาติ (ผู้ปกครอง)<span class="text-red"> *</span>',
      text: props.infoData?.parent?.nationality || '-',
      csg_text: csg_data.value?.EQ_NATIONALITY ? csg_data.value?.EQ_NATIONALITY.replace('สัญชาติ','') : '-'
    }]
    parentAllDataMatch = await isAllDataMatched(parent_data,'CSG');
       infoToBeCompareCSG.value.push(...parent_data);
  } else if(csg_data.value?.EQ_REGISTER_TYPE != 'ผู้ปกครอง'){
  csg_AllDataMatch = await isAllDataMatched([
    // {
    //   field: "csg_status",
    //   label: "สถานะเด็ก<span class="text-red"> *</span>",
    //   text: props.infoData?.csg?.status || '-',
    //   csg_text: csg_data.value?.csg_status || '-'
    // },
    {
      field: "STATUS",
      label: 'สถานะลงทะเบียน<span class="text-red"> *</span>',
      text: props.infoData?.csg?.register_status || '-',
      csg_text: csg_data.value?.STATUS || '-'
    },
    {
      field: "EQ_REGISTER_TYPE",
      label: 'ประเภทผู้ลงทะเบียน<span class="text-red"> *</span>',
      text: props.infoData?.csg?.registrant_type || '-',
      csg_text: csg_data.value?.EQ_REGISTER_TYPE || '-'
    }],'CSG')
}
   if(!parentAllDataMatch){
      let update_data = {}
       let updatedParent = null;
        if(csg_data.value?.EQ_REGISTER_TYPE === "ผู้ปกครอง"){
          let updates_parent = {
          national_id: csg_data.value?.EQ_IDCARD || '', 
          title: (csg_data.value?.EQ_CODE_PRENAME || '').replace('น.ส.','นางสาว'), 
          name: csg_data.value?.EQ_FIRSTNAME || '', 
          surname: csg_data.value?.EQ_LASTNAME || '',
          nationality: (csg_data.value?.EQ_NATIONALITY || '').replace('สัญชาติ',''),
          birthdate: convertThaiDateToISO(csg_data.value?.EQ_BIRTHDAY) || ''
        };
        updatedParent = {
          ...(props.infoData?.parent || {}), 
          ...updates_parent 
        };
        update_data.parent = updatedParent;
        }
        update_data.csg = {};
        update_data.csg.register_status = csg_data.value?.STATUS || null;
        update_data.csg.status = csg_data.value?.csg_status || null;
        update_data.csg.registrant_type= csg_data.value?.EQ_REGISTER_TYPE || null;
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
                    method: "PUT",
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data:{
                        update:update_data
                    }
                }
                axios(config)
                .then((res)=>{ emit('update-state');
                })
    }else if(!csg_AllDataMatch){
       let update_data = {}
        update_data.csg = {};
        update_data.csg.register_status = csg_data.value?.STATUS || null;
        update_data.csg.status = csg_data.value?.csg_status || null;
        update_data.csg.registrant_type= csg_data.value?.EQ_REGISTER_TYPE || null;
         const config = {
                    url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
                    method: "PUT",
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data:{
                        update:update_data
                    }
                }
                axios(config)
                .then((res)=>{ emit('update-state');
                })
    }

  const allDataMatch = await isAllDataMatched(infoToBeCompareCSG.value,'CSG');

if (allDataMatch) {
  const hasCSG = props.infoData?.linking_system?.some(item => 
    (typeof item === 'object' ? item.system : item) === 'CSG'
  );

  if (!hasCSG) {
    putLinkingSystem(link);
  }
  return false;
} else {
  return true;
}
}
const putLinkingSystem = async (link) => {
  // เตรียมข้อมูล Object ใหม่จากค่า link ที่รับมา
const newSystemEntry = {
  system: link, // ใช้ค่า link จาก console.log(link)
  updated_at: new Date().toISOString().split('T')[0] // วันที่ปัจจุบันรูปแบบ YYYY-MM-DD
};

let get_linking_system = [];

if (props.infoData && props.infoData.linking_system) {
  const originalSystems = props.infoData.linking_system;

  // ค้นหา Index ว่าระบบนี้ (link) เคยมีอยู่ใน Array หรือยัง
  // รองรับทั้งกรณีข้อมูลเก่าที่เป็น String และข้อมูลใหม่ที่เป็น Object
  const existingIndex = originalSystems.findIndex(item => 
    (typeof item === 'object' ? item.system : item) === link
  );

  if (existingIndex !== -1) {
    // กรณี "มีระบบนี้อยู่แล้ว": ให้ Copy ของเดิมมาและเขียนทับตำแหน่งนั้นด้วย Object ใหม่ (เพื่ออัปเดตวันที่)
    get_linking_system = [...originalSystems];
    get_linking_system[existingIndex] = newSystemEntry;
  } else {
    // กรณี "ยังไม่มีระบบนี้": ให้เพิ่ม Object ใหม่ต่อท้าย
    get_linking_system = [...originalSystems, newSystemEntry];
  }
} else {
  // กรณี "ยังไม่มีข้อมูลใน linking_system เลย": สร้าง Array ใหม่พร้อมค่าเริ่มต้น
  get_linking_system = [newSystemEntry];
}

// ส่วนการส่ง API
const token = store.getters["userAuth/getToken"];
const config = {
  url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
  method: "PUT",
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
  },
  data: {
    update: {
      linking_system: get_linking_system
    }
  }
};

axios(config).then((res) => {
  emit('update-profile');
});
// <<<<<<< HEAD
//   console.log(link)
//  let get_linking_system = [];
// if (props.infoData && props.infoData.linking_system) {
//   const originalSystems = props.infoData.linking_system;
  
//   if (originalSystems.includes(link)) {
//     get_linking_system = [...originalSystems];
//   } else {
//     get_linking_system = [...originalSystems, link];
//   }
// } else {
//   get_linking_system = [link];
// }
//    const token = store.getters["userAuth/getToken"];
//                 const config = {
//                     url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
//                     method: "PUT",
//                     headers:{
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": `application/json; charset=utf-8`,
//                     },
//                     data:{
//                         update:{
//                             linking_system: get_linking_system
//                         }
//                     }
//                 }
//                 axios(config)
//                 .then((res)=>{ emit('update-profile');
//                 })
// =======
//   console.log(link);
//   const newSystemEntry = {
//     system: "CSG",
//     updated_at: new Date().toISOString().split('T')[0]
//   };

//   let get_linking_system = [];

//   if (props.infoData && props.infoData.linking_system) {
//     const originalSystems = props.infoData.linking_system;

//     const existingIndex = originalSystems.findIndex(item => 
//       (typeof item === 'object' ? item.system : item) === 'CSG'
//     );

//     if (existingIndex !== -1) {
//       // ถ้ามีอยู่แล้ว ให้ทำการ Update ข้อมูล (เช่น อัปเดตวันที่ใหม่)
//       get_linking_system = [...originalSystems];
//       get_linking_system[existingIndex] = newSystemEntry;
//     } else {
//       // ถ้ายังไม่มี ให้เพิ่ม Object ใหม่เข้าไปต่อท้าย
//       get_linking_system = [...originalSystems, newSystemEntry];
//     }
//   } else {
//     // ถ้ายังไม่มี array เลย ให้สร้างใหม่พร้อมข้อมูลแรก
//     get_linking_system = [newSystemEntry];
//   }

//   const token = store.getters["userAuth/getToken"];
//   const config = {
//     url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
//     method: "PUT",
//     headers: {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": `application/json; charset=utf-8`,
//     },
//     data: {
//       update: {
//         linking_system: get_linking_system
//       }
//     }
//   };

//   axios(config).then((res) => {
//     emit('update-profile');
//   });
// >>>>>>> addDEPConnection
};
// if (allDataMatch) {
//   if(!props.infoData?.linking_system?.includes('CSG')){
//   putLinkingSystem(link);
//   }
//      return false;
// } else {
//      return true;
// }
// }
// const putLinkingSystem = async (link) => {
//   console.log(link)
//  let get_linking_system = [];
// if (props.infoData && props.infoData.linking_system) {
//   const originalSystems = props.infoData.linking_system;
  
//   if (originalSystems.includes('CSG')) {
//     get_linking_system = [...originalSystems];
//   } else {
//     get_linking_system = [...originalSystems, 'CSG'];
//   }
// } else {
//   get_linking_system = ['CSG'];
// }
//    const token = store.getters["userAuth/getToken"];
//                 const config = {
//                     url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
//                     method: "PUT",
//                     headers:{
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": `application/json; charset=utf-8`,
//                     },
//                     data:{
//                         update:{
//                             linking_system: get_linking_system
//                         }
//                     }
//                 }
//                 axios(config)
//                 .then((res)=>{ emit('update-profile');
//                 })
// };
const rawDataToText = (data, dataType) => {
  switch (dataType) {
    case "vital_status":
      switch (data) {
        case 1:
          return "มีชีวิตอยู่";
        case 0:
          return "เสียชีวิต";
        default:
          console.log(
            `สถานะการมีชีวิตต้องเป็นตัวเลข 1 หรือ 0 เท่านั้น แต่นี่เป็น ${data} (เป็น string ก็ไม่ได้)`
          );
          return "ข้อมูลไม่ตรง format";
      }
    case "birthdate":
      if(data){
return new Date(data).toLocaleDateString("th-TH");
      }else{
         return '-';
      }
    default:
      return data;
  }
};

const convertThaiDateToISO = (thaiDate) => {
  const [day, month, yearBE] = thaiDate.split('-');
  
  const yearCE = parseInt(yearBE) - 543;

  const date = new Date(yearCE, parseInt(month) - 1, day);
  return date.toISOString(); 
}
</script>

<style>

</style>